import React, { useEffect } from 'react';
import { Box, Container, Grid, Typography, Button, Card, CardContent, Avatar, IconButton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ShareIcon from '@mui/icons-material/Share';
import FavoriteIcon from '@mui/icons-material/Favorite';
import CommentIcon from '@mui/icons-material/Comment';
import { Helmet } from 'react-helmet-async';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';


export default function SMMSection() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'instant'
    });
  }, []);

  const features = [
    {
      title: "Instagram Marketing",
      description: "Create engaging content and grow your Instagram following with strategic marketing.",
      icon: "📸",
      likes: "3.2K",
      comments: "245"
    },
    {
      title: "Content Strategy",
      description: "Develop a content calendar that resonates with your target audience.",
      icon: "📅",
      likes: "2.9K",
      comments: "198"
    },
    {
      title: "Engagement Management",
      description: "Build meaningful relationships with your followers through active engagement.",
      icon: "💬",
      likes: "3.4K",
      comments: "256"
    },
    {
      title: "Analytics & Insights",
      description: "Track performance metrics and optimize your social media strategy.",
      icon: "📊",
      likes: "2.8K",
      comments: "187"
    }
  ];

  const benefits = [
    "Increased brand awareness",
    "Higher engagement rates",
    "Better audience targeting",
    "Cost-effective marketing",
    "Real-time feedback",
    "Viral potential"
  ];

  return (
    
     <>
     
<Box
  sx={{
    position: 'fixed',
    top: { xs: 50, sm: 70 },
    left: { xs: 12, sm: 24 },
    zIndex: 1200,
    bgcolor: 'white',
    borderRadius: '50%',
    boxShadow:5,
    width: { xs: 40, sm: 48 },
    height: { xs: 40, sm: 48 },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }}
>
  <IconButton
    onClick={() => navigate(-1)}
    size="medium"
    sx={{
      color: '#1877f2',
      p: 0.5
    }}
  >
    <ArrowBackIosNewIcon fontSize="small" />
  </IconButton>
</Box>
      <Helmet>
        <title>Best Social Media Marketing Company in Anakapalli & Visakhapatnam | SLGT Digital</title>
        <meta name="description" content="SLGT Digital is the top-rated Social Media Marketing company in Anakapalli & Visakhapatnam. Instagram growth, content strategy, and audience engagement that gets results." />
        <meta name="keywords" content="Best Social Media Marketing Company Anakapalli, Social Media Marketing Visakhapatnam, No.1 SMM Agency Vizag, Instagram Marketing Vizag, SMM Services Anakapalli, SLGT Digital Marketing" />
        <link rel="canonical" href="https://www.slgt.in/services/social-media-marketing" />
        <meta property="og:title" content="Social Media Marketing in Visakhapatnam | SLGT Digital" />
        <meta property="og:description" content="Get professional SMM services for Instagram and beyond. Reach your audience and grow your brand online." />
        <meta property="og:url" content="https://www.slgt.in/services/social-media-marketing" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://www.slgt.in/assets/services/smm-1.jpg" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            "name": "Social Media Marketing Services",
            "provider": {
              "@type": "Organization",
              "name": "SLGT Digital",
              "url": "https://www.slgt.in"
            },
            "areaServed": [
              { "@type": "City", "name": "Anakapalli" },
              { "@type": "City", "name": "Visakhapatnam" }
            ],
            "description": "Professional Social Media Marketing services for Instagram growth, content creation, and community engagement in Anakapalli and Visakhapatnam.",
            "serviceType": "Marketing Service"
          })}
        </script>
      </Helmet>
    <Box sx={{ 
      pt: { xs: 8, sm: 10 },
      pb: { xs: 6, sm: 8 },
      minHeight: '100vh',
      bgcolor: '#fafafa'
    }}>
      {/* Hero Section */}
      <Box 
        sx={{ 
          bgcolor: '#ffffff',
          color: '#262626',
          py: { xs: 6, md: 8 },
          mb: { xs: 4, md: 6 },
          boxShadow: '0 1px 2px rgba(0,0,0,0.1)'
        }}
      >
        <Container maxWidth="lg">
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={6}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                <Avatar 
                  sx={{ 
                    width: 56, 
                    height: 56, 
                    mr: 2,
                    bgcolor: '#e4405f'
                  }}
                >
                  IG
                </Avatar>
                <Box>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 600,
                      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
                      color: '#262626'
                    }}
                  >
                    Social Media Marketing
                  </Typography>
                  <Typography
                    sx={{
                      color: '#8e8e8e',
                      fontSize: '0.9rem',
                      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif'
                    }}
                  >
                    Professional Social Media Services
                  </Typography>
                </Box>
              </Box>
              <Typography
                variant="h1"
                sx={{
                  fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
                  fontWeight: 700,
                  mb: { xs: 2, md: 3 },
                  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
                  color: '#262626',
                  lineHeight: 1.2
                }}
              >
               Is your Brand Getting the Attention it Deserves?
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { xs: '1rem', sm: '1.1rem' },
                  mb: { xs: 3, md: 4 },
                  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
                  color: '#8e8e8e',
                  lineHeight: 1.6
                }}
              >
                Build a strong social media presence and connect with your audience through engaging content.
              </Typography>
              <Button
                variant="contained"
                onClick={() => navigate('/requestquotes')}
                sx={{
                  bgcolor: '#e4405f',
                  color: 'white',
                  '&:hover': { bgcolor: '#c13584' },
                  px: { xs: 4, sm: 6 },
                  py: { xs: 1.5, sm: 2 },
                  fontSize: { xs: '1rem', sm: '1.1rem' },
                  fontWeight: 600,
                  borderRadius: '6px',
                  textTransform: 'none'
                }}
              >
                Get Started
              </Button>
            </Grid>
            <Grid item xs={12} md={6} sx={{ display: { xs: 'none', md: 'block' } }}>
              <img
                src="/assets/services/smm-1.jpg"
                alt="Social Media Marketing Illustration"
                style={{
                  width: '100%',
                  maxWidth: '500px',
                  height: 'auto',
                  display: 'block',
                  margin: '0 auto',
                  borderRadius: '8px'
                }}
              />
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Features Section */}
      <Container maxWidth="lg" sx={{ mb: { xs: 6, md: 8 } }}>
        <Typography
          variant="h2"
          sx={{
            fontSize: { xs: '1.75rem', sm: '2rem', md: '2.5rem' },
            fontWeight: 700,
            mb: { xs: 4, md: 6 },
            textAlign: 'center',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
            color: '#262626',
            lineHeight: 1.2
          }}
        >
          Our Social Media Services
        </Typography>
        <Grid container spacing={3}>
          {features.map((feature, index) => (
            <Grid item xs={12} sm={6} key={index}>
              <Card 
                sx={{ 
                  height: '100%',
                  borderRadius: '8px',
                  boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
                  bgcolor: '#ffffff',
                  border: '1px solid #dbdbdb'
                }}
              >
                <CardContent sx={{ p: 0 }}>
                  {/* Post Header */}
                  <Box sx={{ p: 2, borderBottom: '1px solid #dbdbdb' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Avatar sx={{ width: 40, height: 40, mr: 2, bgcolor: '#e4405f' }}>
                        {feature.icon}
                      </Avatar>
                      <Box>
                        <Typography
                          sx={{
                            fontWeight: 600,
                            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
                            color: '#262626'
                          }}
                        >
                          {feature.title}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: '0.9rem',
                            color: '#8e8e8e',
                            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif'
                          }}
                        >
                          Professional Social Media Service
                        </Typography>
                      </Box>
                    </Box>
                  </Box>

                  {/* Post Content */}
                  <Box sx={{ p: 2 }}>
                    <Typography
                      sx={{
                        color: '#262626',
                        fontSize: '1rem',
                        lineHeight: 1.6,
                        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif'
                      }}
                    >
                      {feature.description}
                    </Typography>
                  </Box>

                  {/* Post Actions */}
                  <Box sx={{ 
                    p: 1, 
                    borderTop: '1px solid #dbdbdb',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                  }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <IconButton size="small" sx={{ color: '#e4405f' }}>
                        <FavoriteIcon />
                      </IconButton>
                      <Typography sx={{ color: '#8e8e8e', fontSize: '0.9rem' }}>
                        {feature.likes}
                      </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <IconButton size="small" sx={{ color: '#8e8e8e' }}>
                        <CommentIcon />
                      </IconButton>
                      <Typography sx={{ color: '#8e8e8e', fontSize: '0.9rem' }}>
                        {feature.comments}
                      </Typography>
                    </Box>
                    <IconButton size="small" sx={{ color: '#8e8e8e' }}>
                      <ShareIcon />
                    </IconButton>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* Benefits Section */}
      <Box sx={{ bgcolor: '#ffffff', py: { xs: 6, md: 8 } }}>
        <Container maxWidth="lg">
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: '1.75rem', sm: '2rem', md: '2.5rem' },
              fontWeight: 700,
              mb: { xs: 4, md: 6 },
              textAlign: 'center',
              fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
              color: '#262626',
              lineHeight: 1.2
            }}
          >
            Benefits of Social Media Marketing
          </Typography>
          <Grid container spacing={3}>
            {benefits.map((benefit, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Card 
                  sx={{ 
                    height: '100%',
                    borderRadius: '8px',
                    boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
                    bgcolor: '#ffffff',
                    border: '1px solid #dbdbdb'
                  }}
                >
                  <CardContent sx={{ p: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Avatar 
                        sx={{ 
                          width: 40, 
                          height: 40, 
                          mr: 2,
                          bgcolor: '#e4405f'
                        }}
                      >
                        ✓
                      </Avatar>
                      <Typography
                        sx={{
                          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
                          fontSize: '1rem',
                          color: '#262626',
                          fontWeight: 500
                        }}
                      >
                        {benefit}
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* CTA Section */}
      <Container maxWidth="lg" sx={{ mt: { xs: 6, md: 8 }, textAlign: 'center' }}>
        <Card 
          sx={{ 
            borderRadius: '8px',
            boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
            bgcolor: '#ffffff',
            p: { xs: 3, md: 4 }
          }}
        >
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: '1.75rem', sm: '2rem', md: '2.5rem' },
              fontWeight: 700,
              mb: 3,
              fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
              color: '#262626',
              lineHeight: 1.2
            }}
          >
            Ready to Grow Your Social Media Presence?
          </Typography>
          <Typography
            sx={{
              mb: 4,
              fontSize: { xs: '1rem', sm: '1.1rem' },
              maxWidth: '800px',
              mx: 'auto',
              color: '#8e8e8e',
              lineHeight: 1.6,
              fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif'
            }}
          >
            Let's create a powerful social media strategy that helps you connect with your audience and grow your brand.
          </Typography>
          <Button
            variant="contained"
            onClick={() => navigate('/requestquotes')}
            sx={{
              bgcolor: '#e4405f',
              color: 'white',
              '&:hover': { bgcolor: '#c13584' },
              px: { xs: 4, sm: 6 },
              py: { xs: 1.5, sm: 2 },
              fontSize: { xs: '1rem', sm: '1.1rem' },
              fontWeight: 600,
              borderRadius: '6px',
              textTransform: 'none'
            }}
          >
            Request a Quote
          </Button>
        </Card>
      </Container>
    </Box>
  );
  </>
  );
}
